import { defineComponent as _defineComponent } from 'vue'
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useCart } from '@/composables/useCart';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';


export default /*#__PURE__*/_defineComponent({
  __name: 'RemovedGiftNotice',
  props: {
    rejectedGifts: null
  },
  setup(__props: any) {



const { translate } = useGetTranslations();
const { isTalonOneEnabled } = useFeatureFlagTalonOne();
const { setGiftRejection, cancelGiftRejection } = useCart();

const cancelRemoveGift = (product: { id: string }) => {
  if (isTalonOneEnabled) {
    cancelGiftRejection(product);
  } else {
    setGiftRejection(product, false);
  }
};

return { __sfc: true,translate, isTalonOneEnabled, setGiftRejection, cancelGiftRejection, cancelRemoveGift, AzIcon }
}

})